import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class ProductFilters {
    static key = 'ProductFilters';

    constructor(el) {
        this.el = el;

        this.activeTypes = [];
        this.activeSeries = [];

        this.cards = Array.from(this.el.querySelectorAll('.js-card'));
        this.groups = Array.from(this.el.querySelectorAll('.js-group'));
        this.emptyState = this.el.querySelector('.js-empty');

        this.typeButtons = this.el.querySelectorAll('[data-filter-type]');
        this.serieButtons = this.el.querySelectorAll('[data-filter-serie]');

        this.init();
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        this.typeButtons.forEach((btn) => {
            btn.addEventListener('click', this.onTypeClick.bind(this));
        });

        this.serieButtons.forEach((btn) => {
            btn.addEventListener('click', this.onSerieClick.bind(this));
        });
    }

    onTypeClick(e) {
        const btn = e.currentTarget;
        const value = btn.dataset.filterType;

        this.toggleFilterValue(this.activeTypes, value);
        btn.classList.toggle('is-active');

        this.update();
    }

    onSerieClick(e) {
        const btn = e.currentTarget;
        const value = btn.dataset.filterSerie;

        this.toggleFilterValue(this.activeSeries, value);
        btn.classList.toggle('is-active');

        this.update();
    }

    toggleFilterValue(list, value) {
        const index = list.indexOf(value);

        if (index > -1) {
            list.splice(index, 1);
        } else {
            list.push(value);
        }
    }

    update() {
        this.updateCardsVisibility();
        this.updateGroupsVisibility();
        this.updateCardContainersVisibility();
        this.updateGroupingState();
        this.updateEmptyState();

        ScrollTrigger.refresh();
    }

    updateCardsVisibility() {
        this.cards.forEach((card) => {
            const type = card.dataset.type;
            const serie = card.dataset.serie;

            const matchesType = this.activeTypes.length === 0 || this.activeTypes.includes(type);

            const matchesSerie =
                this.activeSeries.length === 0 || this.activeSeries.includes(serie);

            const shouldShow = matchesType && matchesSerie;

            card.classList.toggle('is-hidden', !shouldShow);
        });
    }

    updateGroupsVisibility() {
        this.groups.forEach((group) => {
            const visibleCards = group.querySelectorAll('.js-card:not(.is-hidden)');
            const hasVisibleCards = visibleCards.length > 0;

            group.classList.toggle('is-hidden', !hasVisibleCards);
        });
    }

    updateCardContainersVisibility() {
        const largeContainers = this.el.querySelectorAll('.product-card--large');
        const smallContainers = this.el.querySelectorAll('.product-card--small');

        largeContainers.forEach((container) => {
            const visibleCards = container.querySelectorAll('.js-card:not(.is-hidden)');
            container.classList.toggle('is-empty', visibleCards.length === 0);
        });

        smallContainers.forEach((container) => {
            const visibleCards = container.querySelectorAll('.js-card:not(.is-hidden)');
            container.classList.toggle('is-empty', visibleCards.length === 0);
        });
    }

    updateGroupingState() {
        const isTypeMode = this.activeTypes.length > 0;
        this.el.classList.toggle('is-grouped-by-type', isTypeMode);
    }

    updateEmptyState() {
        const hasVisibleCard = this.el.querySelector('.js-card:not(.is-hidden)');

        this.el.classList.toggle('is-empty', !hasVisibleCard);
    }
}
